// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3zpAF","sendOtp":"AuthorizeToLogin_sendOtp__1OUDm"};